<template>
  <div class="autocomplete">
    <div class="input-group">
      <div class="input-group-addon"><i class="fas fa-search"></i></div>
      <input
      type="text"
      v-model="search.fullName"
      @input="onChange"
      class="form-control"
      >
      <a @click="dismiss" class="input-group-addon"><i class="fas fa-times"></i></a>
    </div>
    <ul
    v-show="isOpen"
    class="autocomplete-results"
    >
      <li
      v-for="(result, i) in results"
      :key="i"
      @click="setResult(result)"
      class="autocomplete-result">
      {{ result.fullName}}
      </li>
    </ul>
    <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
  </div>
</template>
<script>
  export default {
    name: 'calCustomers',
    props: {
      items:{
        type: Array
      },
      value:{
        type: Object
      },
      name:{
        type: String
      },
      dismissOption: {
        return: false
      }
    },
    data() {
      return {
        search: this.value,
        results: {},
        isOpen: false,
        names: [],
        errors: {}
      };
    },
    mounted() {
      this.getCustomersName()
      this.$emit('input', this.value === null ? '' : this.value)
        Event.listen('errors', (e) => {
            this.errors = e
        })

    },
    watch: {
      value: function(newVal, oldVal) { // watch it
        this.search = newVal
      },
      dismissOption: function(newVal, oldVal) { // watch it
        this.isOpen = newVal
      }
    },
    methods: {
      onChange(event) {
        console.log(this.value)
        this.isOpen = true;
        this.filterResults();
        this.$delete(this.errors, this.name)
      },
      dismiss() {
        this.isOpen = false
        this.$parent.dropCustomer()
      },
      getCustomersName() {
        this.items.forEach(element => {
        this.names.push(element)
        });
      },
      filterResults() {
        this.results = this.names.filter(item => item.fullName.toLowerCase().indexOf(this.search.fullName.toLowerCase()) > -1);
        console.log(this.names)
      },
      setResult(result) {
        this.search = result
        this.isOpen = false
        this.$emit('input', result)
        this.$parent.$delete(this.$parent.errors, this.name)
      },
    }
  };
</script>
<style scoped>
  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
</style>